import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {
    IEntityWithIDTranslations,
    IEntityWithTranslations,
    IErrorResponse,
    IRootState,
} from "../../../../../../../types";
import {
    deletedRestoreSocialStatus,
    deletedSocialStatus,
    setSocialStatus,
    setSocialStatusRestore,
    updateSocialStatus,
} from "../store/socialStatusSlice";

const GetSocialStatus = createAsyncThunk("get/social", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/student-social");
        dispatch(setSocialStatus({ data: response.data }));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetSocialStatus = createAsyncThunk("set/social", async (data: IEntityWithTranslations, { rejectWithValue }) => {
    try {
        const response = await request.post("/student-social", data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteSocialStatus = createAsyncThunk("delete/social", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/student-social/${id}`);

        dispatch(deletedSocialStatus(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditSocialStatus = createAsyncThunk(
    "edit/social",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-social/${data.id}`, data);
            dispatch(updateSocialStatus(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteSocialStatus = createAsyncThunk("get/delete/social", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/student-social/deleted-items`);

        dispatch(setSocialStatusRestore(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteSocialStatus = createAsyncThunk(
    "restore/delete/social",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/student-social/restore/${id}`);
            dispatch(deletedRestoreSocialStatus(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
export {
    GetSocialStatus,
    SetSocialStatus,
    DeleteSocialStatus,
    EditSocialStatus,
    GetDeleteSocialStatus,
    RestoreDeleteSocialStatus,
};
